import { KEY_PREFIX } from 'marketplace-ui-common/hooks/useSearchParams';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Paths } from '../../constants/paths';
import { useFilterConfig } from '../../filters/hooks/useFilterConfig';
import { INITIAL_POPULAR_COUNT, INITIAL_POPULAR_INDUSTRY_COUNT, POPULAR_INDUSTRY_SLUGS, POPULAR_SERVICE_SLUGS } from '../constants/find-partner-match';
import { useGetPartnerCount } from './useGetPartnerCount';
export function useFindPartnerMatch(onClose) {
  const [step, setStep] = useState(1);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const partnerCount = useGetPartnerCount(selectedService, selectedIndustries);
  const {
    PROFILE_CATALOG_SERVICES: serviceFilter,
    PROFILE_INDUSTRIES: industryFilter
  } = useFilterConfig({
    productTypes: ['SOLUTIONS_PARTNER_PROFILE']
  });
  const serviceOptions = serviceFilter !== null && serviceFilter !== void 0 && serviceFilter.options ? [...serviceFilter.options] : [];
  const allPopularServices = !(serviceFilter !== null && serviceFilter !== void 0 && serviceFilter.options) ? [] : POPULAR_SERVICE_SLUGS.map(slug => serviceFilter.options.find(o => o.slug === slug)).filter(option => !!option && option.value !== selectedService);
  const popularServices = showMore ? allPopularServices : allPopularServices.slice(0, INITIAL_POPULAR_COUNT);
  const industryOptions = industryFilter !== null && industryFilter !== void 0 && industryFilter.options ? [...industryFilter.options] : [];
  const popularIndustries = !(industryFilter !== null && industryFilter !== void 0 && industryFilter.options) ? [] : POPULAR_INDUSTRY_SLUGS.map(slug => industryFilter.options.find(o => o.slug === slug)).filter(option => !!option && !selectedIndustries.includes(option.value)).slice(0, INITIAL_POPULAR_INDUSTRY_COUNT);
  const navigateToResults = industries => {
    if (!selectedService) return;
    const urlParams = new URLSearchParams(location.search);
    urlParams.set(`${KEY_PREFIX}PROFILE_CATALOG_SERVICES`, selectedService);
    urlParams.delete(`${KEY_PREFIX}PROFILE_INDUSTRIES`);
    industries.forEach(industry => {
      urlParams.append(`${KEY_PREFIX}PROFILE_INDUSTRIES`, industry);
    });
    history.push({
      pathname: Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS,
      search: `?${urlParams.toString()}`
    });
    onClose();
  };
  const handleNext = () => {
    if (step === 1) {
      if (!selectedService) return;
      setStep(2);
    } else {
      navigateToResults(selectedIndustries);
    }
  };
  const handleSkip = () => {
    navigateToResults([]);
  };
  return {
    step,
    setStep,
    selectedService,
    setSelectedService,
    selectedIndustries,
    setSelectedIndustries,
    showMore,
    setShowMore,
    partnerCount,
    serviceOptions,
    allPopularServices,
    popularServices,
    industryOptions,
    popularIndustries,
    handleNext,
    handleSkip
  };
}